import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import ThemeToggle from './ThemeToggle';
import { useTheme } from '../context/ThemeContext';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { darkMode } = useTheme();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <NavLink to="/" className="logo">
          <span className="logo-prefer">Preferro</span>
          <span className="logo-build">Build</span>
        </NavLink>
        <div className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <NavLink 
            to="/" 
            className={({isActive}) => isActive ? "nav-link active" : "nav-link"}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </NavLink>
          <NavLink 
            to="/about" 
            className={({isActive}) => isActive ? "nav-link active" : "nav-link"}
            onClick={() => setMenuOpen(false)}
          >
            About
          </NavLink>
          <NavLink 
            to="/projects" 
            className={({isActive}) => isActive ? "nav-link active" : "nav-link"}
            onClick={() => setMenuOpen(false)}
          >
            Projects
          </NavLink>
          <NavLink 
            to="/services" 
            className={({isActive}) => isActive ? "nav-link active" : "nav-link"}
            onClick={() => setMenuOpen(false)}
          >
            Services
          </NavLink>
          <NavLink 
            to="/contact" 
            className={({isActive}) => isActive ? "nav-link active" : "nav-link"}
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </NavLink>
          <div className="nav-cta">
            <a href="/contact" className="btn">Get a Quote</a>
          </div>
          <ThemeToggle />
        </div>
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
